module.exports = Jsw.skinUrl + "/images/AI-colored.svg?ee8fafae625b33576ded21c3760e6c49";